// inspired by https://auth0.com/blog/role-based-access-control-rbac-and-react-apps/
/*
 Example usage:

 <May
  roles={user.roles}
  perform="dashboard-page:visit"
  yes={() => (
    <h2>User can do it</h2>
  )}
  no={() => <h2>User can't do it</h2>}
/>
*/
import rules from "../../../constants/Permissions";
import keycloak from "../../../keycloak"

const check = (rules, action, data) => {

  if (!action) {
    return true;
  }

  const roles = (keycloak && keycloak.tokenParsed) ? keycloak.tokenParsed.realm_access.roles : [];
  
  if (roles) {
    // for ( var role of roles) {
    for ( var i = 0; i < roles.length; i++) {
      const permissions = rules[roles[i]];
      if (permissions) {

        const staticPermissions = permissions.static;
    
        if (staticPermissions && staticPermissions.includes(action)) {
          // static rule provided for action
          return true;
        }
      
        const dynamicPermissions = permissions.dynamic;
      
        if (dynamicPermissions) {
          const permissionCondition = dynamicPermissions[action];
          if (permissionCondition && permissionCondition(data)) {
            return true;
          }
        }

      }
    }

    return false;
  } else {
    return false;
  }
};

const May = props =>
  check(rules, props.perform, props.data)
    ? props.yes()
    : props.no();

May.defaultProps = {
  yes: () => null,
  no: () => null
};

export default May;